/* istanbul ignore file */

export enum BulkSiteUploadShapefileStep {
    UploadFile = 0,
    MatchAttributes = 1,
    ActivateSites = 2,
    Review = 3
}

export enum BulkSiteUploadShapefileSiteTemplateStep {
    UploadFile = 0,
    MatchAttributes = 1,
    ActivateSites = 2,
    SiteTemplate = 3,
    Review = 4
}

export enum BulkSiteUploadExcelStep {
    UploadFile = 0,
    Review = 1
}

export enum BulkSiteUploadExcelSiteTemplateStep {
    UploadFile = 0,
    SiteTemplate = 1,
    Review = 2
}
